import { render, staticRenderFns } from "./PremiumPackaging.vue?vue&type=template&id=6f4ea729"
import script from "./PremiumPackaging.vue?vue&type=script&lang=js"
export * from "./PremiumPackaging.vue?vue&type=script&lang=js"
import style0 from "./PremiumPackaging.vue?vue&type=style&index=0&id=6f4ea729&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports